import React from 'react';
import Dropdown from 'react-dropdown';
import cn from 'classnames';
import { DateRangePicker } from 'react-dates';
import Button from 'components/common/Button';

function getGuestItems(guestCount) {
  const arr = new Array(guestCount);
  for (let i=0; i<guestCount; i++) {
    arr[i] = getGuestsItem(i+1, guestCount);
  }
  return arr;
}

function getGuestsItem(guests, maxGuests) {
  const value = String(guests);
  if (value === String(maxGuests)) {
    return { label: guests + "+", value };
  } else {
    return { label: value, value };
  }
}

export default class SearchForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      focusedInput: null
    };

    this.onSearch = this.onSearch.bind(this);
  }

  onSearch() {
    const { onSearch, startDate, endDate, guests, city } = this.props;
    onSearch({
      startDate,
      endDate,
      guests,
      city
    });
  }

  render() {
    const { cities, maxGuests, city, startDate, endDate, guests, onCityChange, onDateChange, onGuestChange, color, numberOfMonths } = this.props;
    const { focusedInput } = this.state;

    return (
      <div className={cn("row", "no-gutters", "search-form", "justify-content-center")}>
        <div className="mr-md-15 mb-md-0 mb-45 search-form-city">
          <Dropdown placeholder="City" options={cities} value={ city } onChange={onCityChange}/>
        </div>
        <div className="mr-md-15 mb-md-0 mb-45 col-md-auto col-12">
          <DateRangePicker
            startDatePlaceholderText="Check in"
            endDatePlaceholderText="Check out"
            startDate={startDate} // momentPropTypes.momentObj or null,
            endDate={endDate} // momentPropTypes.momentObj or null,
            onDatesChange={onDateChange} // PropTypes.func.isRequired,
            focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
            onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
            showClearDates
            numberOfMonths={numberOfMonths}
          />
        </div>
        <div className="mr-md-15 mb-md-0 mb-45 search-form-guests">
          <Dropdown placeholder="Guests" options={getGuestItems(maxGuests)} value={guests && getGuestsItem(guests, maxGuests)} onChange={onGuestChange}/>
        </div>
        <div className="col-md-auto d-flex col-12 search-form-button">
          <Button size="lg" onClick={this.onSearch} style={{background: color}}>Search</Button>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SearchForm.js